import { useCallback } from "react";
import { Row, Col } from "antd";
import { hueService } from "/app/src/services";
import { useTranslation } from "react-i18next";
import { Button } from "@heroui/react";
import { toast } from "sonner";

/**
 * Open a new window with the given URL
 */
function openURL(url: string) {
  if (typeof window !== "undefined") {
    window.open(url);
  }
}

/**
 * Creates a new integration interface for adding a new bridge.
 * @returns {JSX.Element} The React component for the new integration page.
 */
export default function NewIntegration() {
  const { t } = useTranslation();

  /**
   * Connects to the bridge service and opens the URL if successful.
   */
  const connectBridge = useCallback(() => {
    hueService.getHueHealth().then((response) => {
      if (response.status === "error") {
        toast.error(
          "Lights API credentials incomplete. Please ensure the App settings have been configured.",
        );
      } else {
        hueService.getURL({}).then((response) => {
          if (response.errors) {
            toast.error(response.errors[0]);
          } else {
            openURL(response.url);
          }
        });
      }
    });
  }, []);

  return (
    <div className="newIntegration">
      <Row justify="start">
        <Col span={24}>
          <Button
            color="primary"
            radius="none"
            onPress={connectBridge}
            size="md"
            fullWidth
          >
            {t("translation:add")} {t("translation:new_bridge")}
          </Button>
        </Col>
      </Row>
    </div>
  );
}
